import { styled } from 'styled-components';

export const AccordionSaveRow = styled.div`
  & > button {
    *:not(:first-child) {
      margin-left: ${({ theme }) => theme.sizing.small};
    }
  }
  /*the Button Group component */
  & > div {
    float: right;

    button {
      *:not(:first-child) {
        margin-left: ${({ theme }) => theme.sizing.small};
      }
    }
  }
`;
AccordionSaveRow.displayName = 'AccordionSaveRow';

export const DeleteModalContent = styled.div`
  width: 50vw;

  div {
    margin-bottom: ${({ theme }) => theme.sizing.small};
  }
`;
DeleteModalContent.displayName = 'DeleteModalContent';

export const ExplanationBlurb = styled.div`
  span {
    white-space: pre-wrap;
  }
`;
ExplanationBlurb.displayName = 'ExplanationBlurb';
